import { render, staticRenderFns } from "./billing.vue?vue&type=template&id=04b8665a&"
import script from "./billing.vue?vue&type=script&lang=js&"
export * from "./billing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports